export const cookiesConfig = {
    lastUpdated: "2025-08-05",
    title: "Cookie Policy",
    intro: "At LiveLoveSpain, we use cookies and similar technologies to enhance your user experience, ensure secure access to our services, provide personalized recommendations, and serve relevant advertisements. This policy explains how we use cookies, what they do, and how you can control them.",
    sections: [
      {
        title: "1. What Are Cookies?",
        content: 
          "Cookies are small text files stored on your device when you visit our platform. They help us recognize your device, remember your preferences, and provide features essential to the functioning of our platform."
      },
      {
        title: "2. Types of Cookies We Use",
        subsections: [
          {
            title: "2.1 Essential Cookies",
            content:
              "These cookies are necessary for the platform to function and cannot be disabled. They include session cookies for login authentication, secure payment handling, and session management."
          },
          {
            title: "2.2 Performance and Analytics Cookies",
            content:
              "We use these cookies to collect anonymized data about how users interact with our platform. This helps us improve user experience and platform performance. For example, we use Google Analytics to monitor traffic and usage patterns."
          },
          {
            title: "2.3 Functional Cookies",
            content:
              "These cookies help us remember your preferences and improve your experience. For instance, they store your selected language or other personal settings."
          },
          {
            title: "2.4 Advertising and Marketing Cookies",
            content:
              "These cookies are used to deliver personalized advertisements and measure their effectiveness. We use Google AdSense to serve ads that are relevant to your interests based on your browsing behavior. We also use Endorsly for affiliate program tracking to properly attribute sales to our marketing partners. Endorsly cookies are whitelisted for affiliate tracking to ensure proper commission attribution when users come through affiliate links. These cookies help fund our free services and content."
          },
          {
            title: "2.5 Third-Party Cookies",
            content:
              "Third-party cookies are set by services we integrate with, such as Google OAuth for login, Stripe for payments, Google AdSense for advertising, Endorsly for affiliate tracking, and MongoDB Atlas for database interactions."
          }
        ]
      },
      {
        title: "3. Similar Technologies We Use",
        content:
          "In addition to cookies, we use local storage and session storage technologies to temporarily save user session data, preferences, and authentication tokens to ensure a seamless experience."
      },
      {
        title: "4. Why We Use Cookies",
        content:
          "We use cookies and similar technologies to: \n" +
          "- Authenticate users and maintain sessions.\n" +
          "- Process payments securely through Stripe.\n" +
          "- Analyze usage patterns and improve the platform with tools like Google Analytics.\n" +
          "- Serve personalized advertisements through Google AdSense.\n" +
          "- Track affiliate program performance and commission attribution.\n" +
          "- Store and retrieve user preferences, such as selected language.\n\n" +
          "**Important:** Endorsly affiliate tracking cookies are whitelisted to ensure proper commission attribution when users come through affiliate links, regardless of general cookie consent preferences. Other advertising cookies require your explicit consent."
      },
      {
        title: "5. Managing Your Cookie Preferences",
        content:
          "You have control over cookies and can manage them via our platform's consent banner and through your browser settings. You can choose to accept or decline advertising cookies while still using our core services. However, disabling essential cookies may impact platform functionality, including login and payment processing. To change your advertising preferences, clear your browser cookies and revisit our site."
      },
      {
        title: "6. Third-Party Cookies and Tracking",
        content:
          "We integrate with third-party services that may set cookies on your device. These include:\n" +
          "- **Google Analytics:** For monitoring platform usage and user behavior.\n" +
          "- **Google AdSense:** For serving personalized advertisements and measuring ad performance.\n" +
          "- **Stripe:** For secure payment processing.\n" +
          "- **Google OAuth:** For login authentication.\n" +
          "- **Endorsly:** For affiliate program tracking and commission attribution (whitelisted for affiliate links).\n" +
          "We recommend reviewing their privacy policies to understand how they use your data. You can control most advertising cookies through your consent preferences, but Endorsly cookies are whitelisted for affiliate tracking."
      },
      {
        title: "7. Data Retention and Security",
        content:
          "Cookies and similar technologies are used to store your data securely. Session data is retained only as long as your session is active, while analytics data may be retained for analysis purposes. We follow industry-standard security measures to protect this data."
      },
      {
        title: "8. Updates to This Policy",
        content:
          "We may update this Cookie Policy to reflect changes in our practices or legal requirements. Any updates will be posted on this page with a revised 'last updated' date."
      },
      {
        title: "9. Contact Us",
        content:
          "If you have any questions about our use of cookies, please contact us at support@livelovespain.com."
      }
    ]
  };
  